// The chart type here is the unit of y-axis in the chart.

import { RawAssetTypeCode } from 'types/models/asset-type';
import { UnitType } from 'utils/get-unit-by-country';

export enum TankChartType {
  LEVEL = 'tankUnits',
  PERCENT = 'tankPercent',
  LITRES = 'tankLitres',
  GALLONS = 'tankGallons'
}

export enum FlowChartType {
  VOLUME_SM = 'litres',
  VOLUME_SM_PER_MIN = 'litresPerMinute',
  VOLUME_LG = 'megaLitres'
}

export const FLOW_CHART_TYPE_TO_UNIT_TYPE: Record<FlowChartType, UnitType> = {
  [FlowChartType.VOLUME_SM]: UnitType.VOLUME_SM,
  [FlowChartType.VOLUME_SM_PER_MIN]: UnitType.FLOW,
  [FlowChartType.VOLUME_LG]: UnitType.VOLUME_LG
};

export enum GasFlowChartType {
  RATE = 'gasFlowRate',
  VOLUME = 'gasFlowVolume'
}

export const GAS_FLOW_CHART_TYPE_TO_UNIT_TYPE: Record<GasFlowChartType, UnitType> = {
  [GasFlowChartType.RATE]: UnitType.FLOW_GAS,
  [GasFlowChartType.VOLUME]: UnitType.VOLUME_GAS
};
/*
 * We added prefix `advancedDam` to differentiate from SimpleDamChartType, because TypeScript doesn't check duplicate
 * enum values in switch case.
 */
export enum AdvancedDamChartType {
  VOLUME = 'advancedDamVolume',
  PERCENT = 'advancedDamPercent',
  REDUCED_LEVEL = 'advancedDamReducedLevel',
  LEVEL = 'advancedDamLevel'
}

export enum SimpleDamChartType {
  VOLUME = 'volume',
  PERCENT = 'percent',
  LEVEL = 'level'
}

export enum TroughDirectChartType {
  LEVEL = 'troughDirectLevel',
  PERCENT = 'troughDirectPercent'
}

export enum PowerMeterChartType {
  VOLTAGE = RawAssetTypeCode.POWER_METER_VOLTAGE,
  CURRENT = RawAssetTypeCode.POWER_METER_CURRENT,
  ENERGY = RawAssetTypeCode.POWER_METER_ENERGY
}

export enum BarChartType {
  /** Data aggregated into intervals (e.g., hourly, daily, or weekly sums). Typically used for rainfall or ET sensors. */
  INTERVAL_AGGREGATED = 'intervalAggregated',
  /** Continuous data */
  TIME_SERIES = 'timeSeries'
}

export enum HeaterChartType {
  // If we do not provide a value, the first entry will evaluate to 0, making it hard to distinguish between
  // a valid chartType versus an empty chartType.
  TEMPERATURE_AND_CYCLES = 'temperatureAndCycles',
  ENERGY = 'energy'
}

export type SampleChartType =
  | AdvancedDamChartType
  | BarChartType
  | FlowChartType
  | GasFlowChartType
  | HeaterChartType
  | PowerMeterChartType
  | SimpleDamChartType
  | TankChartType
  | TroughDirectChartType;